<ng-container *ngIf="useHeaderCard; else noHeaderCard">
  <ui-fh-card [innerClass]="'py-0'">
    <div class="d-flex flex-row align-items-center gap-4">
      <ui-fh-text
        [type]="'CARD-TITLE'"
        [text]="('generics.status') | translate">
      </ui-fh-text>

      <div class="status-label"
           [ngClass]="status.toLowerCase()"
           role="status"
           aria-live="polite"
           [attr.aria-label]="(translateKeyPrefix + status.toLowerCase()) | translate">
        <ui-fh-text
          [type]="'SMALL'"
          [class]="'m-0'"
          [text]="(translateKeyPrefix + status.toLowerCase()) | translate">
        </ui-fh-text>
      </div>
    </div>
  </ui-fh-card>
</ng-container>
<ng-template #noHeaderCard>
  <div class="status-label"
       [ngClass]="status.toLowerCase()"
       role="status"
       aria-live="polite"
       [attr.aria-label]="(translateKeyPrefix + status.toLowerCase()) | translate">
    <ui-fh-text
      [type]="'SMALL'"
      [class]="'m-0'"
      [text]="(translateKeyPrefix + status.toLowerCase()) | translate">
    </ui-fh-text>
  </div>
</ng-template>
